<template>
  <div class="fileshare">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>文件分享页面</span>
      </div>

      <!-- 上传区域 -->
      <el-upload
        class="upload-area"
        drag
        :action="uploadUrl"
        :headers="uploadHeaders"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">拖拽文件到此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">支持任意文件类型，单文件不超过 100MB</div>
      </el-upload>

      <el-divider></el-divider>

      <!-- 文件列表 -->
      <h3>已分享文件</h3>
      <el-table :data="fileList" style="width: 100%" stripe v-loading="loading">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="name" label="文件名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="size" label="大小" width="100">
          <template slot-scope="scope">
            {{ formatSize(scope.row.size) }}
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="上传时间" width="180"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="copyLink(scope.row)">复制链接</el-button>
            <el-button type="text" size="small" @click="downloadFile(scope.row)">下载</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" @click="deleteFile(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { listFiles, deleteFile } from '../api/fileshare'

export default {
  name: 'fileshare',
  data () {
    return {
      uploadUrl: '/noauth/file/upload',
      uploadHeaders: {},
      fileList: [],
      loading: false
    }
  },
  mounted () {
    this.loadFiles()
  },
  methods: {
    beforeUpload (file) {
      const maxSize = 100 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过 100MB')
        return false
      }
      return true
    },
    handleUploadSuccess (response) {
      this.$message.success('上传成功')
      this.loadFiles()
    },
    handleUploadError () {
      this.$message.error('上传失败')
    },
    loadFiles () {
      this.loading = true
      listFiles().then(response => {
        this.fileList = response.data || []
      }).catch(() => {
        this.$message.error('加载文件列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    formatSize (size) {
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
      if (size < 1024 * 1024 * 1024) return (size / 1024 / 1024).toFixed(2) + ' MB'
      return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    },
    copyLink (file) {
      const link = window.location.origin + '/noauth/file/download?id=' + file.id
      this.$copyText(link).then(() => {
        this.$message.success('链接已复制')
      }).catch(() => {
        const textarea = document.createElement('textarea')
        textarea.value = link
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('链接已复制')
      })
    },
    downloadFile (file) {
      window.open('/noauth/file/download?id=' + file.id, '_blank')
    },
    deleteFile (file) {
      this.$confirm('确定要删除文件 ' + file.name + ' 吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteFile(file.id).then(() => {
          this.$message.success('删除成功')
          this.loadFiles()
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.fileshare {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  max-width: 1400px;
  margin: 0 auto;
}
.upload-area {
  text-align: center;
  padding: 30px 0;
}
</style>


// WEBPACK FOOTER //
// src/view/fileshare.vue